import { TRACKING_SOURCES, type TrackingSource } from './types';

export interface HuginConfig {
  apiBaseUrl: string;
  cookieDomain: string;
  source: TrackingSource;
  /** When false, tracking waits for an explicit `window.hugin.consent()` call. */
  autoTrack: boolean;
  /** When true, respect the browser's Do Not Track signal. */
  doNotTrack: boolean;
}

function isTrackingSource(value: string): value is TrackingSource {
  return (TRACKING_SOURCES as readonly string[]).includes(value);
}

function parseSource(raw: string | undefined): TrackingSource {
  if (raw && isTrackingSource(raw)) return raw;
  return 'web';
}

export function resolveApiBaseUrl(
  datasetValue: string | undefined,
  builtIn: string,
): string {
  return datasetValue?.replace(/\/$/, '') || builtIn;
}

export function readConfig(): HuginConfig | null {
  const script = document.currentScript as HTMLScriptElement | null;
  if (!script) return null;

  const { dataset } = script;

  const apiBaseUrl = resolveApiBaseUrl(dataset.apiBaseUrl, __API_BASE_URL__);
  if (!apiBaseUrl) return null;

  return {
    apiBaseUrl,
    cookieDomain: dataset.cookieDomain ?? '.timeshifter.com',
    source: parseSource(dataset.source),
    autoTrack: dataset.autoTrack !== 'false',
    doNotTrack: dataset.doNotTrack === 'true',
  };
}
